import React from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { classIf } from '../../data/utils/classIf';


function MatchLink(props) {
    const appContext = React.useContext(AppContext);
    const relativeMatchPath = useAbsolutePath([props.urlPath, props.urlPathSuffix].join(''),null,props.urlPathSeo,true);
    const noFollow = isSeoSettingsNoFollow(props.urlPathSeoSettings);

    function handleClick(e){
        if (window.blockHistoryChanges()) {
            e.preventDefault();
            props.openMatch();
        }else{
            appContext.setHandleOpenFromPath(true);
            props.openMatch();
        }
       
    }

    return (
        <Link to={encodeURI(relativeMatchPath) } onClick={handleClick} {...(noFollow ? {rel: 'nofollow'}:{})} >
             <div key={props.uniqueId} className={"event-desc text-small" + classIf(props.selected, 'selected')}>
                {props.team2 ?
                    <div className="d-flex flex-column align-items-start">
                        <span>{props.team1}</span>
                        <span>{props.team2}</span>
                    </div>
                    :
                    <span>{props.team1}</span>
                }
                <span className="push-right">{props.date}</span>
            </div>
        </Link>
    );
}

export default MatchLink;